export default __webpack_public_path__ + "static/media/Conectvidad_la_clave_para_un_negocio_rentable_version.c88b4e5e.pdf";